import createReducer from 'utils/create-reducer';
import { createLoader } from 'utils/create-loader';
import { initState, handleEditMeSuccess, handleLoginSuccess, handleVerifySuccess, handleLogoffSuccess, handleSavingFacebookData } from '../entities/User';
import _ from 'lodash';

const ACTION_TYPES = {
  setProfile: 'USER_SET_PROFILE',
  setTempRegisteredUser: 'SET_TEMP_REGISTER_PROFILE',
  setFirebaseUserId: 'SET_FIREBASE_USER_ID',
};

const initialState = {
  firebaseUserId: null,
  me: null,
  tempRegisteredProfile: null,
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.setProfile:
      return {
        ...state,
        me: action.profile,
      };
    case ACTION_TYPES.setTempRegisteredUser:
      return {
        ...state,
        tempRegisteredProfile: action.profile,
      };
    case ACTION_TYPES.setFirebaseUserId:
      return {
        ...state,
        firebaseUserId: action.userId,
      };
    default:
      return state;
  }
};

export { reducer };

export const setProfile = (profile) => ({
  type: ACTION_TYPES.setProfile,
  profile: profile,
});

// const initialState = initState();
// export const reducer = createReducer(initialState, {
//   ...userRegisterLoader.reducers,
//   ...userListLoader.reducers,
//   ...allUserListLoader.reducers,
//   ...addAdminLoader.reducers,
//   ...updatePermssionsLoader.reducers,
//   ...userDetailLoader.reducers,
//   ...editUserLoader.reducers,
//   ...deleteAdminLoader.reducers,
//   ...userLoginLoader.reducers,
//   ...userVerifyLoader.reducers,
//   ...rejectUserLoader.reducers,
//   ...verifyUserLoader.reducers,
//   ...userClassListLoader.reducers,
//   ...userChangePasswordLoader.reducers,
//   ...userSendInterestingCategoriesLoader.reducers,
//   ...getPointListLoader.reducers,
//   ...getSpentPointListLoader.reducers,
//   ...banUserByIdLoader.reducers,
//   ...addPointsLoader.reducers,
//   [editUserLoader.success]: (state, action) => handleEditMeSuccess(action.result)(state),
//   [userLoginLoader.success]: (state, action) => handleLoginSuccess(action.result)(state),
//   [userVerifyLoader.success]: (state, action) => handleVerifySuccess(action.result)(state),
//   [userLogoffLoader.success]: (state, action) => handleLogoffSuccess(action.result)(state),
//   [ACTION_TYPES.saveFacebookUserData]: (state, action) => handleSavingFacebookData(action.facebookId, action.facebookToken)(state),
// });

// export const getUsers = (params) => userListLoader.get('/users', { params });
// export const getAllUsers = (params) => allUserListLoader.get('/users', { params: { ...params, limit: 10000, page: 1 } });
// export const getUserById = (id) => userDetailLoader.get(`/users/${id}`);
// export const addAdmin = (data) => addAdminLoader.post('/users/admin', { data });
// export const updatePermissions = (data) => updatePermssionsLoader.put('/users/admin', { data });
// export const deleteAdmin = (id) => deleteAdminLoader.del(`/users/admin/${id}`);
// export const banUserById = (id) => banUserByIdLoader.post(`/users/${id}/ban`);
// export const addPoints = (id, data) => addPointsLoader.post(`/users/${id}/points`, { data });
// export const register = (data) => userRegisterLoader.post('/users', { data });
// export const verify = () => userVerifyLoader.get('/users/me');
// export const editUser = (id, data) => editUserLoader.put(`/users/${id}`, { data });
// export const loginEmail = (data) => userLoginLoader.post('/users/login', { data });
// export const logoff = (data = '') => userLogoffLoader.post('/users/logout', { data });
// export const getUserClassList = (params) => userClassListLoader.get('/users/me/classes', { params });
// export const changePassword = (data) => userChangePasswordLoader.post('/users/change-password', { data });
// export const isVerified = (userStore) => !!_.get(userStore, 'me.email');
// export const verifyUser = (id) => verifyUserLoader.post(`/users/${id}/verify`);
// export const rejectUser = (id) => rejectUserLoader.post(`/users/${id}/reject`);
// export const sendInterestingCategories = (data) => userSendInterestingCategoriesLoader.post('/users/interesting-categories', { data });
// export const getPointList = (id, params) => getPointListLoader.get(`/users/${id}/points`, { params });
// export const getSpentPointList = (id, params) => getSpentPointListLoader.get(`/users/${id}/spent-points`, { params });
// // export const hasToken = () => !!Utils.getToken();
// export const saveFacebookUserData = ({ facebookId, facebookToken }) => ({
//   type: ACTION_TYPES.saveFacebookUserData,
//   facebookId,
//   facebookToken,
// });

// export const saveUser(me) =>
